var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('img',{staticStyle:{"width":"80%"},attrs:{"src":"logo.png","alt":"logo"}})])])])
}]

export { render, staticRenderFns }